import { createState as createGlobxState } from 'globx';
import merge from 'helpful-merge';

import createAssetStore from './Asset/createAssetStore';
import createConfigStore from './Config/createConfigStore';
import createConcurrencyStore from './Concurrency/createConcurrencyStore';
import createPlaybackStore from './Playback/createPlaybackStore';
import createPrecisionStore from './Precision/createPrecisionStore';
import createResumePointsStore from './ResumePoints/createResumePointsStore';
import createUserActionsStore from './UserActions/createUserActionsStore';
import ingestGlobalConfigFromEnvironment from './Shared/Util/ingestGlobalConfigFromEnvironment';

const createState = (initialState = {}) => {
    const state = createGlobxState();

    const consumerConfig = initialState.config;
    const globalConfig = ingestGlobalConfigFromEnvironment();

    const prePopulatedConfig = merge(globalConfig, consumerConfig, true);

    createAssetStore(state);
    createConfigStore(state, prePopulatedConfig);
    createConcurrencyStore(state);
    createPlaybackStore(state);
    createPrecisionStore(state);
    createResumePointsStore(state);
    createUserActionsStore(state);

    return state;
};

export default createState;
